/** Shared `?ver=&t=` cache-bust helpers (runtime + Vite build). */

export interface ICacheBustTokens {
    ver: string;
    t: string;
}

/** Dotted package version → query `ver` (`5.10.3` → `5_10_3`). */
export function packageVersionAsVer(version: string): string {
    return version.replace(/\./g, '_');
}

export function cacheBustQuery(ver: string | number, t: string | number): string {
    return `?ver=${ver}&t=${t}`;
}

/** Appends `ver`/`t` when the URL does not already include `ver`. */
export function withCacheBust(url: string, ver: string | number, t: string | number): string {
    if (/[?&]ver=/.test(url)) {
        return url;
    }
    const query = cacheBustQuery(ver, t);
    return url.includes('?') ? `${url}&${query.slice(1)}` : `${url}${query}`;
}

/** Sets or replaces the `t` query (e.g. DEBUG forced refetch). */
export function withCacheBustTimestamp(url: string, t: string | number): string {
    if (/[?&]t=/.test(url)) {
        return url.replace(/([?&])t=[^&]*/, `$1t=${t}`);
    }
    return url.includes('?') ? `${url}&t=${t}` : `${url}?t=${t}`;
}
